import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import Header from "@/components/layout/header";
import FieldMappingsTable from "@/components/field-mappings/field-mappings-table";
import FieldMappingForm from "@/components/field-mappings/field-mapping-form";
import BulkUpdateForm from "@/components/bulk-update/bulk-update-form";

const FieldMappingsPage = () => {
  const [showAddMappingModal, setShowAddMappingModal] = useState(false);
  const [showBulkUpdateModal, setShowBulkUpdateModal] = useState(false);
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    // Update to use the correct API endpoint paths defined in manageMappings.ts
    queryClient.invalidateQueries({ queryKey: ["/api/field-mappings"] });
    // These are likely custom endpoints that might need verification as well
    queryClient.invalidateQueries({ queryKey: ["/api/field-mappings/all"] });
    queryClient.invalidateQueries({ queryKey: ["/api/field-mappings/choices"] });
    // Make sure to invalidate specific statistics queries for the entity
    queryClient.invalidateQueries({ queryKey: ["/api/field-mappings/statistics"] });
    queryClient.invalidateQueries({ queryKey: ["/api/field-mappings/statistics/pl_title"] });
  };

  return (
    <div className="flex flex-col h-full">
      <Header title="Field Mapping Management" onRefresh={handleRefresh} />
      
      <main className="flex-1 overflow-y-auto p-6 bg-[#F5F5F5]">
        <FieldMappingsTable onAddMapping={() => setShowAddMappingModal(true)} />

        <div className="fixed bottom-8 right-8 flex flex-col gap-2">
          <button
            onClick={() => setShowBulkUpdateModal(true)}
            className="bg-[#2B88D8] p-3 rounded-full shadow-lg text-white hover:bg-[#0078D4] transition-colors duration-200"
          >
            <span className="material-icons">tune</span>
          </button>
        </div>
      </main>

      {showAddMappingModal && (
        <FieldMappingForm
          isOpen={showAddMappingModal}
          onClose={() => setShowAddMappingModal(false)}
          onSuccess={() => setShowAddMappingModal(false)}
        />
      )}

      {showBulkUpdateModal && (
        <BulkUpdateForm
          isOpen={showBulkUpdateModal}
          onClose={() => setShowBulkUpdateModal(false)}
          onSuccess={() => setShowBulkUpdateModal(false)}
        />
      )}
    </div>
  );
};

export default FieldMappingsPage;
